import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FilterItem } from 'src/app/models/filter/filter-item';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    standalone: false
})
export class FilterComponent implements OnInit, OnChanges {

  @Input() filterItems: FilterItem<any>[];
  @Input() showAllButton: boolean;
  @Input() showClearButton: boolean;
  @Input() totalCount: number;

  @Output() selectionChange = new EventEmitter<FilterChange>();

  selectedCount = 0;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedCount = this.filterItems.filter(i => i.selected).length;
  }

  /**
   * Handles the reset of the selected property of the filter items and
   * also resets the count
   *
   * @param event - the event
   */
  clearFilter(event: MouseEvent): void {
    this.filterItems.forEach(item => item.selected = false);
    this.selectionChange.emit({nonSelected: true});
    this.selectedCount = 0;
    event.stopPropagation();
  }

  /**
   * Handles the selection event
   *
   * @param filterItem - the selected/deselected filter item
   * @param event - the event
   */
  toggleSelected(filterItem: FilterItem<any>, event: MouseEvent): void {
    filterItem.selected = !filterItem.selected;
    if(filterItem.selected) {
      this.selectedCount++;
    } else {
      this.selectedCount--;
    }

    this.selectionChange.emit({
      newValue: filterItem,
      nonSelected: this.selectedCount === 0
    });
    event.stopPropagation();
  }
}

export interface FilterChange {
  nonSelected: boolean;
  newValue?: FilterItem<any>;
}
